import { useQueryClient } from '@tanstack/react-query';

import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { VerifyEmailSetupRequest } from '../../../../../shared/types/routes/auth/mfa';

import { getMfaMethodsQueryKey } from './useListMfaMethods';

/**
 * Verify email setup code and mark method as verified
 */
export default function useVerifyEmailSetup() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (request: VerifyEmailSetupRequest) => {
      return post<VerifyEmailSetupRequest, void>('/api/auth/mfa/email/verify', request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getMfaMethodsQueryKey() });
    },
    successToastMessage: 'Email MFA setup completed successfully',
    errorToastMessage: 'Failed to verify code. Please check your code and try again.',
  });
}
